
// EditarCompra.js

import React, { useState, useEffect } from 'react';
import TipoField from './TipoField';
import CodigoField from './CodigoField';
import DatepickerField from './DatepickerField';
import CurrencyField from './CurrencyField';
import CondPagamentoSelect from './CondPagamentoSelect';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import Box from '@mui/material/Box';
import ModalDetahesFornecedor from './ModalDetalhesFornecedor'; // Certifique-se de que o caminho está correto
import ModalEditarItensCompra from './ModalEditarItensCompra'; // Certifique-se de que o caminho está correto
import ModalPesquisarFornecedor from './ModalPesquisarFornecedor'; // Adicione esta linha
import ModalContasApagar from './ModalContasApagar';
import ModalBoletoControl from './ModalBoletoControl';
import RelatorioComprasModal from './RelatorioComprasModal'; // Supondo que o modal esteja em outro arquivo
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';
import './ModalBoletoControl.css'; 

function EditarCompra({ compra, handleEditClick, handleCancelaEdit }) {

  const [isSaving, setIsSaving] = useState(false);
  const [detalhesCompra, setDetalhesCompra] = useState(compra);
  const [detalhesFornecedor, setDetalhesFornecedor] = useState(false);


  // eslint-disable-next-line no-unused-vars
  const [itensCompra, setItensCompra] = useState([]);
  const [editarItensCompra, setEditarItensCompra] = useState(false);
  const [codCompraParaEditar, setCodCompraParaEditar] = useState(null);
  const [pesquisarFornecedor, setPesquisarFornecedor] = useState(false); // Estado para controlar a abertura do modal de pesquisa de fornecedores
  const [isContasApagarOpen, setIsContasApagarOpen] = useState(false);


  const [formData, setFormData] = useState({
    id: 0,       // Valor inicial para id da compra
    codcompra: '',
    dtcompra: '',
    tipo: '',

    idfornecedor: 0,  // Estado para armazenar dados do fornecedor selecionado
    nomefor: '',
    codfor: '',
    cnpjfor: '',
    empresa: '',
    codemp: '',
    cnpjemp: '',

    nfcompra: '',
    valcompra: 0, // Valor inicial para valcompra
    formapag: '',
    condpag: '',
    dtnfcompra: '',

    pesoliqd: 0,
    pesobruto: 0,
    unidade: '',
    entregues: 0,
    devolvidos: 0,
    saldo: 0,

    grupo: '',
    grupodesc: '',
    conta: '',
    contadesc: '',

    romaneio: '',
    placa: '',
    motorista: '',
    ajudante: '',
  });

  useEffect(() => {
    // Atualiza os detalhes da compra quando o componente é montado
    if (compra) {
      setFormData({
        ...compra,
        id: compra.id, // Certifique-se de armazenar o ID da compra no estado
        idfornecedor: compra.fornecedor ? compra.fornecedor.id : '',
        nomefor: compra.fornecedor ? compra.fornecedor.nomefor : '',
        codfor: compra.fornecedor ? compra.fornecedor.codfor : '',
        cnpjfor: compra.fornecedor ? compra.fornecedor.cnpjfor : '',
        valcompra: compra.valcompra, // Atualizando valcompra no estado
      });
      setCodCompraParaEditar(compra.codcompra); // Definir o código da compra para atualizar
    }
  }, [compra]);

  const idCompra = compra ? compra.id : 0; // Captura o 'id' da compra, ou define como 'null' se não houver Compra
  const idFornecedor = compra ? compra.fornecedor.id : 0; // Captura o 'id' do Fornecedor, ou define como 'null' se não houver Fornecedor

  useEffect(() => {
    // Atualiza os detalhes da compra ao definir o código da compra
    if (codCompraParaEditar) {
      fetchCompraPorCodcompra(codCompraParaEditar);
    }
  }, [codCompraParaEditar]);


  useEffect(() => {
    const saldo = formData.entregues - formData.devolvidos;
    setFormData(prevData => ({
      ...prevData,
      saldo,
    }));
  }, [formData.entregues, formData.devolvidos]);


  const fetchItensCompra = (codcompra) => {
    api.get(`/comprasitem/${codcompra}/itens`)
      .then(response => setItensCompra(response.data))
      .catch(error => console.error('Erro ao buscar itens da compra:', error));
  };

  const fetchCompraPorCodcompra = async (codcompra) => {
    try {
      const response = await api.get(`/compras/buscarcompra?codcompra=${codcompra}`);

      if (response.data) {
        setDetalhesCompra(response.data);
        setFormData(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar compra por Código da Compra:', error);
    }
  };

  const handleSaveItens = () => {
    api.get(`/comprasitem/${detalhesCompra.codcompra}/itens`)
      .then(response => {
        setItensCompra(response.data);
        fetchCompraPorCodcompra(detalhesCompra.codcompra);
      })
      .catch(error => console.error('Erro ao atualizar itens da compra:', error));
  };


// Função para abrir ou fechar o modal de Editar Itens da Compra
  const toggleEditarItensCompra = (codcompra) => {
    if (!editarItensCompra && codcompra) {
      setCodCompraParaEditar(codcompra);
      fetchItensCompra(codcompra);
    }
    setEditarItensCompra(!editarItensCompra);
  };


  // Função para fechar o modal de Editar Itens da Compra e dar refresh
  const handleFecharModalEditarItensCompra = () => {
    console.log('Modal de Edição Itens da Compra Fechado'); // Adicionando log
    setEditarItensCompra(false);
    fetchCompraPorCodcompra(codCompraParaEditar); // Atualiza os detalhes da compra após editar os itens
  };

// Função para abrir ou fechar o modal de Contas a Pagar
    const toggleContasApagar = () => {
    setIsContasApagarOpen(!isContasApagarOpen);
  };

  const handleSaveContasApagar = () => {
    // Lógica adicional após salvar contas a receber, se necessário
    console.log('Contas a Receber salvas com sucesso.');
    toggleContasApagar();
  };

  const paymentMethods = ['', 'Em Espécie', 'PIX', 'Cartão', 'Boleto', 'Depósito', 'Transferência'];
  const conditionMethods = ['', 'À Vista', '15 dias', '30 dias', '60 dias', '30-60 dias', '30-60-90 dias'];

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };


  // Função para obter a data atual no formato yyyy-mm-dd
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };


  const handleSalvaEditada = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomefor', 'cnpjfor'];
    const hasErrors = mandatoryFields.some(field => {
      const value = formData[field];
      console.log(`Campo ${field}:`, value);
      return typeof value !== 'string' || value.trim() === '';
   });

    if (hasErrors) {
      alert('A Seleção do Fornecedor é Obrigatória.');
      return;
    }
    // Se a data da Compra estiver vazia, define a data atual
    if (!formData.dtcompra.trim()) {
      formData.dtcompra = getDataAtualISO();
    }
    setIsSaving(true);
    try {
      console.log('Enviando dados da Compra:', formData);
      const response = await api.put(`/compras/alterarcompra/${compra.codcompra}`, formData, {
        headers: { 'Content-Type': 'application/json'},
      });

      console.log('Compra editada com sucesso:', response.data);
      handleEditClick(response.data); // Atualiza a lista de Compras e redireciona

      } catch (error) {
      console.error('Erro ao editar Compra:', error.response ? error.response.data : error.message);
    } finally {
      setIsSaving(false);
    }
  };


  const handleFornecedorSelecionado = (fornecedor) => {
    setFormData({
      ...formData,
      codfor: fornecedor.codfor,
      nomefor: fornecedor.nomefor,
      cnpjfor: fornecedor.cnpjfor,
    });
    setPesquisarFornecedor(false);
  };

  // Função para abrir ou fechar os detalhes do fornecedor
  const toggleDetalhesFornecedor = () => {
    setDetalhesFornecedor(!detalhesFornecedor);
  };


  // eslint-disable-next-line no-unused-vars
  const handleOpenModalPesquisaFornecedor = () => setPesquisarFornecedor(true);
  const handleCloseModalPesquisaFornecedor = () => setPesquisarFornecedor(false);


  const [showModalBoleto, setShowModalBoleto] = useState(false);

  const handleOpenModalBoleto = () => setShowModalBoleto(true);
  const handleCloseModalBoleto = () => setShowModalBoleto(false);

const [openRelatorioModal, setOpenRelatorioModal] = useState(false);

  const handleOpenRelatorioModal = () => setOpenRelatorioModal(true);
  const handleCloseRelatorioModal = () => setOpenRelatorioModal(false);


  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

      <div style={{ marginBottom: '20px'}}>
        <h3>Edição de Compras</h3>
      </div>

      {/* Campos de Edição da Compra */}

        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px'  }}>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Compra</label>
              <CodigoField value={formData.codcompra || ''} onChange={value => handleChange('codcompra', value)} />
            </div>
          

            <div style={{ width: '120px', marginBottom: '0px' }}>
              <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data da Compra</label>
            <DatepickerField value={formData.dtcompra || ''} onChange={value => handleChange('dtcompra', value)}
            style={{ width: '120px', height: '28px', marginBottom: '0px' }} />
            </div>
        

            <div style={{ width: '160px', marginBottom: '0px' , marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '160px', marginBottom: '0px'  }}>Tipo da Compra</label>
            <TipoField value={formData.tipo || ''} onChange={value => handleChange('tipo', value)} />
            </div>

            <div style={{ marginLeft: '20px', marginBottom: '0px'  }}>
              <button onClick={() => toggleEditarItensCompra(compra.codcompra) || ''} style={{ width: '100px', marginBottom: '0px' , marginTop: '20px', height: '30px' }}>Editar Itens</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
            <button className="btn-truncate" title="Seleção Fornecedor"
              onClick={() => setPesquisarFornecedor(true)} style={{ width: '140px', marginTop: '20px', height: '30px' }}
            >Seleção Fornecedor</button>
            </div>

            <div style={{ marginLeft: '20px', marginBottom: '0px'  }}>
            <button className="btn-truncate" title="Ficha Fornecedor"
              onClick={toggleDetalhesFornecedor} style={{ width: '110px', marginTop: '20px', marginBottom: '0px', height: '30px' }}>Ficha Fornecedor</button>
            </div>

          </div>

          <div style={{ display: 'flex', marginTop: '0px' }}>

            <div style={{ marginRight: '20px', marginTop: '0px', width: '420px' }}>
              <label style={{ display: 'block', width: '420px', marginTop: '0px', marginRight: '20px' }}>Fornecedor</label>
            <input type="text" value={formData.nomefor || ''} onChange={e => handleChange('nomefor', e.target.value)}
              readOnly style={{ width: '420px', marginTop: '0px', marginRight: '20px', height: '30px' }} />
            </div>
          
            <div style={{ width: '100px', marginTop: '0px' }}>
            <label title="Código Fornecedor" style={{ display: 'block', width: '100px', marginTop: '0px',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} translate="no">Cód. Fornecedor</label>
              <input type="text" value={formData.codfor || ''} onChange={e => handleChange('codfor', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
          
            <div style={{ width: '150px', marginTop: '0px' }}>
              <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ Fornecedor</label>
              <input type="text" value={formData.cnpjfor || ''} onChange={e => handleChange('cnpjfor', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
            </div>
          
            <div style={{ marginLeft: '20px', marginBottom: '0px' }}>
              <button
              onClick={() => window.open('https://amei.sebrae.com.br/auth/realms/externo/protocol/openid-connect/auth?forent_id=emissor-nfe-frontend&redirect_uri=https%3A%2F%2Femissornfe.sebrae.com.br%2F&state=3e67ca49-22c2-4e8f-8e58-335c65748c49&response_mode=fragment&response_type=code&scope=openid&nonce=4fa8e9a6-0700-4a53-bf92-27ff79eaff34', '_blank', 'noopener,noreferrer')}
              style={{ width: '100px', marginTop: '24px', marginBottom: '0px', marginLeft: '20px', height: '30px' }}
              >Nota Fiscal</button>
            </div>
                     
          </div>
        

        <div style={{ display: 'flex', marginBottom: '0px' }}>
          
          <div style={{ marginRight: '20px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px' }}>Empresa</label>
            <input type="text" value={compra.empresa || ''} readOnly style={{ width: '420px', height: '30px' }} />
          </div>

          <div style={{ width: '100px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '100px', marginTop: '0px' }} translate="no">Cód. Empresa</label>
            <input type="text" value={formData.codemp || ''} onChange={e => handleChange('codemp', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>  
          
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ Empresa</label>
            <input type="text" value={formData.cnpjemp || ''} onChange={e => handleChange('cnpjemp', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>
          
          <div style={{ marginLeft: '20px', marginBottom: '0px' }}>
            <button className="open-modal-button" onClick={handleOpenModalBoleto}
            style={{ width: '100px', marginTop: '24px', marginBottom: '0px', marginLeft: '20px', height: '30px' }}
            >Boletos</button>
          </div>

        </div>

        
        <div style={{ display: 'flex', marginBottom: '0px' }}>

          <div style={{ width: '100px', marginRight: '0px' }}>
          <label style={{ display: 'block', width: '100px', marginBottom: '0px', marginRight: '20px' }}>Nota Fiscal</label>
          <input type="text" value={formData.nfcompra || ''} onChange={e => handleChange('nfcompra', e.target.value)}
          style={{ width: '100px', height: '28px' }} />
          </div>

          
          <div style={{ width: '100px', marginLeft: '20px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '100px' }}>Valor Compra</label>
          <CurrencyField value={formData.valcompra || ''} onChange={value => handleChange('valcompra', value)} />
          </div>
          
          <div style={{ width: '200px', marginLeft: '20px', marginBottom: '0px' }}>
          <FormaPagamentoSelect 
          paymentMethods={paymentMethods} 
          selectedMethod={formData.formapag} 
          onChange={(value) => handleChange('formapag', value) || ''} />
          </div>
          
          <div style={{ width: '230px', marginLeft: '20px', marginBottom: '0px' }}>
          <CondPagamentoSelect 
          conditionMethods={conditionMethods} 
          selectedMethod={formData.condpag} 
          onChange={(value) => handleChange('condpag', value) || ''} />
          </div>
          
          <div style={{ marginLeft: '20px', marginBottom: '0px', marginTop: '5px'  }}>
          <button onClick={toggleContasApagar}
              style={{ width: '100px', marginLeft: '20px', marginBottom: '0px', marginTop: '20px', height: '30px' }}
              translate="no">A Pagar</button>
          </div>

        </div>          

        <div style={{ display: 'flex', marginBottom: '0px' }}>


          <div style={{ width: '120px', marginLeft: '0px' }}>
            <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data Nota Fiscal</label>
            <DatepickerField value={formData.dtnfcompra || ''} onChange={value => handleChange('dtnfcompra', value)}
            style={{ width: '120px', height: '28px' }}/>
          </div>
          <div style={{ width: '80px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginLeft: '0px' }} translate="no">Peso Liqd.</label>
            <input type="text" value={formData.pesoliqd || 0} onChange={e => handleChange('pesoliqd', e.target.value)}
              style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginLeft: '0px'  }}>Peso Bruto</label>
            <input type="text" value={formData.pesobruto || 0} onChange={e => handleChange('pesobruto', e.target.value)}
              style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70x', marginLeft: '0px' }}>Unidade</label>
            <input type="text" value={formData.unidade || ''} onChange={e => handleChange('unidade', e.target.value)}
            style={{ width: '70px', height: '30px' }} />
          </div>
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginLeft: '0px' }}>Entregue</label>
            <input type="text"value={formData.entregues || 0} onChange={e => handleChange('entregues', parseFloat(e.target.value) || 0)}
            style={{ width: '70px', height: '30px' }} />
          </div>         
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginLeft: '0px' }}>Devolvido</label>
            <input type="text" value={formData.devolvidos || 0} onChange={e => handleChange('devolvidos', parseFloat(e.target.value) || 0)}
            style={{ width: '70px', height: '30px' }} />
          </div>
          <div style={{ width: '60px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '60px', marginLeft: '0px' }}>Saldo</label>
            <input type="text" value={formData.saldo || 0} readOnly
            style={{ width: '60px', height: '30px' }} />
          </div>

          <div style={{ marginLeft: '40px', marginBottom: '0px', marginTop: '5px'  }}>
            <button onClick={handleOpenRelatorioModal}
              style={{ width: '100px', marginLeft: '20px', marginBottom: '0px', marginTop: '20px', height: '30px' }}>
            Relatórios</button>
            </div>
        
        </div>
                                            
      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px' }}>Grupo</label>
          <input type="text" value={compra.grupo || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '180px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '180px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={compra.grupodesc || ''} readOnly style={{ width: '180px', height: '30px' }} />
        </div>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px', marginRight: '20px'  }}>conta</label>
          <input type="text" value={compra.conta || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '240px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '240px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={compra.contadesc || ''} readOnly style={{ width: '240px', height: '30px' }} />
        </div>   
      </div>          


      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px' }}>Romaneio</label>
          <input type="text" value={compra.romaneio || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px', marginRight: '20px' }}>Veículo</label>
          <input type="text" value={compra.placa || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px'  }}>Motorista</label>
          <input type="text" value={compra.motorista || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px' }}>Ajudante</label>
          <input type="text" value={compra.ajudante || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>   
      </div>     
                                      
       {/* Modal Detalhes do Fornecedor */}
      {detalhesFornecedor && compra?.fornecedor && (
          <ModalDetahesFornecedor
            fornecedor={compra.fornecedor}
            fecharDetalhes={toggleDetalhesFornecedor}
          />
        )}
        

       {/* Modal Pesquisar Fornecedor */}
      {pesquisarFornecedor && (
        <ModalPesquisarFornecedor
        isOpen={pesquisarFornecedor}
        onClose={handleCloseModalPesquisaFornecedor}
        onFornecedorSelecionado={handleFornecedorSelecionado}
        />
      )}

      {/* Modal Editar Itens da Compra*/}         
      {editarItensCompra && (
        <ModalEditarItensCompra
          isOpen={editarItensCompra}
          fecharModal={handleFecharModalEditarItensCompra}
          codCompra={codCompraParaEditar}
          onSave={handleSaveItens}
         />
      )}

      {/* Modal ModalContasApagar */}
      {isContasApagarOpen && (
        <ModalContasApagar
        isOpen={isContasApagarOpen}
        dadosCompra={compra} 
        codCompra={compra.codcompra} 
        valCompra={compra.valcompra}  // Use a variável com o valor atualizado
        fecharModal={toggleContasApagar}
        onSave={handleSaveContasApagar}
        />
      )}

      <ModalBoletoControl
          isOpen={showModalBoleto}
          codCompra={compra.codcompra} 
        onClose={handleCloseModalBoleto}
      />   

        <RelatorioComprasModal
          open={openRelatorioModal}
          handleClose={handleCloseRelatorioModal}
          idCompra={idCompra}  // Passa o ID da Compra para o Modal
          codCompra={formData.codcompra}  // Passa o Código do Fornecedor para o Modal
          idFornecedor={idFornecedor}  // Passa o ID do Fornecedor para o Modal
          codFor={formData.codfor}  // Passa o Código do Fornecedor para o Modal
        />

    <br/>

      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
          <button  type="button" className='btn-menu' onClick={handleSalvaEditada} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
          {isSaving ? 'Salvando...' : 'Salvar'}
          </button>
          <button  type="button" className='btn-menu' onClick={handleCancelaEdit} style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>
            Cancelar
          </button>
          </div>
        </Box>
          
        </div>

    </div>

  );
};

export default EditarCompra;